import { IDocumentRepository } from "$src/domain/projects/documents/IDocumentRepository";
import { DocumentSummary } from "$src/domain/projects/documents/DocumentSummary";
import { ApiRoutes } from "$src/infrastructure/apiConfig/ApiRoutes";
import { BaseApi } from "$src/infrastructure/apiConfig/BaseApi";
import { injectable } from "tsyringe";
import { BlobResult } from "$src/infrastructure/network/BlobResult";
import { DocumentIdentifier } from "$src/domain/projects/documents/DocumentIdentifier";
import { AxiosProgressEvent } from "axios";
import { DocumentMeta } from "$src/domain/projects/documents/DocumentMeta";

@injectable()
export class DocumentRepositoryApi extends BaseApi implements IDocumentRepository {

    protected static getRoute(groupStoreId: string, projectId: string, path: string) : string {
        return `${ApiRoutes.DOCUMENTS.endpoint(groupStoreId, projectId)}/${path}`;
    }

    async getDocuments(groupStoreId: number, projectId: number): Promise<DocumentSummary[]> {
        try {
            const route = DocumentRepositoryApi.getRoute(groupStoreId.toString(), projectId.toString(), '');

            return await this.apiClient.get<DocumentSummary[]>(route);
        } catch (error) {
            console.error('Error fetching documents by project id:', error);
            throw error; 
        }
    }

    async getDocument(groupStoreId: number, projectId: number, documentId: string) : Promise<DocumentSummary> {
        try {
            const route = DocumentRepositoryApi.getRoute(groupStoreId.toString(), projectId.toString(), documentId);

            return await this.apiClient.get(route);
        } catch (error) {
            console.error('Error fetching document by id:', error);
            throw error; 
        }
    }
  
    async getDocumentFileBlobUrl(groupStoreId: number, projectId: number, documentId: string) : Promise<BlobResult> {
        try {
            const route = DocumentRepositoryApi.getRoute(groupStoreId.toString(), projectId.toString(), `${documentId}/file`);

            return await this.apiClient.getBlobUrl(route);
        } catch (error) {
            console.error('Error fetching document File by id:', error);
            throw error; 
        }
    }

    async createDocument(groupStoreId: number, projectId: number, file: File, onUploadProgress?: (progressEvent: AxiosProgressEvent) => void): Promise<DocumentIdentifier> {
        try {
            const route = DocumentRepositoryApi.getRoute(groupStoreId.toString(), projectId.toString(), '');

            const formData = new FormData();
            formData.append('file', file);

            return await this.apiClient.post(route, formData, undefined, onUploadProgress);
        } catch (error) {
            console.error('Error creating document', error);
            throw error; 
        }
    }

    async updateDocument(groupStoreId: number, projectId: number, documentId: string, meta: DocumentMeta): Promise<DocumentIdentifier> {
        try {
            const route = DocumentRepositoryApi.getRoute(groupStoreId.toString(), projectId.toString(), documentId);
            
            return await this.apiClient.put(route, meta);
        } catch (error) {
            console.error('Error updating document', error);
            throw error; 
        }
    }

    async deleteDocument(groupStoreId: number, projectId: number, documentId: string): Promise<DocumentIdentifier> {
        try {
            const route = DocumentRepositoryApi.getRoute(groupStoreId.toString(), projectId.toString(), documentId);
            
            return await this.apiClient.delete(route);
        } catch (error) {
            console.error('Error deleting document', error);
            throw error; 
        }
    }
}